import { Form } from "react-router-dom";
import Box from "../components/Box/Box";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export default function Fail() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();

    return (
        <div>
            <Form>
                <Box>
                    <h2 ref={h2Ref} id="SendFailed">Ett fel inträffade</h2>
                    <p>Något verkar ha gått fel i din ansökan. Testa gärna igen.</p>
                    <p>Har du frågor kan du kontakta kundservice.</p>
                </Box>
                <div className="flex justify-center">
                    <div className="w-full text-left flex items-center">
                        <BackButton />
                    </div>
                </div>
            </Form>
        </div>
    );
}
